import React, { useState, useContext } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const { FiMail, FiLock, FiAlertCircle, FiShield } = FiIcons;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { isAdmin, login } = useContext(AppContext);
  const navigate = useNavigate();

  if (isAdmin) return <Navigate to="/admin" />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError("Credenziali non valide o errore di connessione.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md league-card p-8 shadow-2xl relative"
      >
        <div className="absolute top-0 left-0 w-full h-2 flex">
          <div className="w-1/2 bg-nba-red"></div>
          <div className="w-1/2 bg-nba-blue"></div>
        </div>

        <div className="text-center mb-8">
          <div className="inline-flex p-4 rounded-full bg-white/5 mb-4">
            <SafeIcon icon={FiShield} className="text-3xl text-white" />
          </div>
          <h1 className="font-league text-4xl text-white uppercase tracking-wider">League Admin</h1>
          <p className="text-white/40 text-xs uppercase tracking-widest mt-2">Authorized Personnel Only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <SafeIcon icon={FiMail} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-nba-dark border border-nba-border p-4 pl-12 text-white outline-none focus:border-white transition-colors font-league text-xl tracking-wider placeholder:text-white/20"
              required
            />
          </div>

          <div className="relative">
            <SafeIcon icon={FiLock} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-nba-dark border border-nba-border p-4 pl-12 text-white outline-none focus:border-white transition-colors font-league text-xl tracking-wider placeholder:text-white/20"
              required
            />
          </div>

          {error && (
            <div className="bg-nba-red/10 border border-nba-red p-3 flex items-center gap-2 text-nba-red text-xs font-bold uppercase tracking-wider">
              <SafeIcon icon={FiAlertCircle} /> {error}
            </div>
          )}

          <button
            disabled={loading}
            className="w-full bg-white text-black font-league text-2xl p-4 hover:bg-gray-200 transition-colors disabled:opacity-50 tracking-wider active:scale-[0.98]"
          >
            {loading ? 'CONNECTING...' : 'LOGIN'}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;